/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { PostUsersLogoutMutationResponse, PostUsersLogout400 } from '../entities/PostUsersLogout'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query'
import { postUsersLogout } from '../api/postUsersLogout'
import { useMutation } from '@tanstack/react-query'

export const postUsersLogoutMutationKey = () => [{ url: '/users/logout' }] as const

export type PostUsersLogoutMutationKey = ReturnType<typeof postUsersLogoutMutationKey>

/**
 * @description Выход из системы
 * @summary Выход из системы
 * {@link /users/logout}
 */
export function usePostUsersLogout<TContext>(
  options: {
    mutation?: UseMutationOptions<PostUsersLogoutMutationResponse, ResponseErrorConfig<PostUsersLogout400>, void, TContext> & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { mutation: { client: queryClient, ...mutationOptions } = {}, client: config = {} } = options ?? {}
  const mutationKey = mutationOptions?.mutationKey ?? postUsersLogoutMutationKey()

  return useMutation<PostUsersLogoutMutationResponse, ResponseErrorConfig<PostUsersLogout400>, void, TContext>(
    {
      mutationFn: async () => {
        return postUsersLogout(config)
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  )
}